import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataAssetCaptureComponent } from './data-asset-capture.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { DataAssetCaptureCreateOrUpdateComponent } from './data-asset-capture-create-or-update/data-asset-capture-create-or-update.component';
import { DataAssetCaptureFileCreateOrUpdateComponent } from './data-asset-capture-file-create-or-update/data-asset-capture-file-create-or-update.component';
import { DataAssetManualCreateOrUpdateComponent } from './data-asset-manual-create-or-update/data-asset-manual-create-or-update.component';
import { DataAssetCaptureRouter } from './data-asset-capture.router';
import { DataAssetsCaptureForAssetSourceComponent } from './data-assets-capture-for-asset-source/data-assets-capture-for-asset-source.component';
import { DataAssetsViewComponent } from './data-assets-view/data-assets-view.component';
import { DataAssetsCaptureForFileAssetSourceComponent } from './data-assets-capture-for-file-asset-source/data-assets-capture-for-file-asset-source.component';
import { SharedModule } from 'src/app/shared/shared.module';



@NgModule({
  declarations: [
    DataAssetCaptureComponent,
    DataAssetCaptureCreateOrUpdateComponent,
    DataAssetCaptureFileCreateOrUpdateComponent,
    DataAssetManualCreateOrUpdateComponent,
    DataAssetsCaptureForAssetSourceComponent,
    DataAssetsViewComponent,
    DataAssetsCaptureForFileAssetSourceComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatIconModule,
    DataAssetCaptureRouter,
    SharedModule
  ]
})
export class DataAssetCaptureModule {}